import { render, staticRenderFns } from "./SportsLayout.vue?vue&type=template&id=781cea20&scoped=true"
import script from "./SportsLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportsLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportsLayout.vue?vue&type=style&index=0&id=781cea20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781cea20",
  null
  
)

export default component.exports